require('../../favorites/favoritesService');

angular.module('app.shared.favoritesCarousel.favoritesCarouselController', [
  'app.favorites.favoritesService'
])
  .controller('app.shared.favoritesCarousel.favoritesCarouselController', [
    '$scope',
    'app.favorites.favoritesService',
    '$filter',
    '$state',
    'PRODUCT',
    function ($scope, favoritesService, $filter, $state, product) {
      "use strict";

      $scope.title = null;
      $scope.favoritesPerSlide = 5;
      $scope.activeSlide = 0;
      $scope.slides = [
        {
          src: 'http://a.deviantart.net/avatars/f/u/funnythingsarefunny.jpg?1'
        },
        {
          src: 'http://a.deviantart.net/avatars/t/r/tremasy.gif?4'
        },
        {
          src: 'https://new1.fjcdn.com/avatars/49117f_614824_big.gif'
        }
      ];
      $scope.allGamesIcon = $scope.allGamesIcon || null;

      let init = () => {
        buildSlides();
      };

      let buildSlides = (favorites, title) => {
        if (!favorites) {
          if (favoritesService.list) {
            favorites = angular.copy(favoritesService.list);
          }
          else {
            favorites = {};
          }

          favorites.append = [
            {
              icon_url: '',
              icon_svg: 'fa-plus-circle',
              icon_txt: 'Add Favorite',
              action: () => {
                $state.go('app.favorites');
              }
            }
          ];
        }

        if (!title && favorites && Array.isArray(favorites.personal) && !favorites.personal.length) {
          if (product.Id === 1) {
            title = 'Add a favorite team, league, or event';
          } else {
            title = 'Add a favorite team or event'
          }
        }
        $scope.title = title || null;

        let slides = [];
        let slide = [];

        let groups = ['public', 'personal', 'append'];
        for (let group_i in groups) {
          if (groups.hasOwnProperty(group_i)) {
            let group = groups[group_i];
            if (Array.isArray(favorites[group])) {
              for (let i in favorites[group]) {
                if (favorites[group].hasOwnProperty(i)) {
                  let favorite = favorites[group][i];

                  switch (favorite.id) {
                    case 10:
                      if ($scope.allGamesIcon) {
                        favorite.icon_url = "";
                        favorite.icon_svg = "fa-star";
                        favorite.icon_txt = "View All";
                      } else {
                        favorite.icon_url = "";
                        favorite.icon_svg = "fa-list-alt";
                        favorite.icon_txt = "All Games";
                      }
                  }

                  if (slide.length >= $scope.favoritesPerSlide) {
                    slides.push(slide);
                    slide = [favorite];
                  }
                  else {
                    slide.push(favorite);
                  }
                }
              }
            }
          }
        }

        if (slide.length) {
          slides.push(slide);
        }

        $scope.slides = slides;
      };

      $scope.isSelected = (favorite) => {
        if (favorite.id) {
          return favoritesService.is_selected(favorite.id);
        }
        return false;
      };

      $scope.favoriteClicked = (favorite) => {
        if (typeof favorite.action === 'function') {
          favorite.action();
        }
        else {
          favoritesService.toggle_selected(favorite.id);
        }
      };

      $scope.clearFavoriteSelection = () => {
        favoritesService.toggle_selected(10);
      };

      $scope.removeFavoriteClicked = (favorite) => {
        buildSlides({
            append: [
              {
                icon_url: favorite.icon_url
              },
              {
                class: 'favorite-keep',
                text: 'Keep',
                action: () => {
                  buildSlides();
                }
              },
              {
                class: 'favorite-delete',
                text: 'Delete',
                action: () => {
                  if (favoritesService.is_favorite(favorite.type, favorite.search_id)) {
                    favoritesService.toggle(favorite.type, favorite.search_id);
                  }
                }
              }
            ]
          },
          'Are you sure you want to delete?');
      };

        // select 'all leagues' on favourites bar
        $scope.selectAllLeagues = function(noBroadcast) {
            if (!favoritesService.is_selected(10)) {
                favoritesService.select(10, noBroadcast);
            }
        };

      $scope.$watch(
        () => {
          if(Array.isArray(favoritesService.list.personal)){
            return favoritesService.list.personal.length
          }
          else return false;
        },
        () => {
          buildSlides();
        }
      );

      $scope.$watch(
        () => {
          return $scope.favoritesPerSlide;
        },
        () => {
          buildSlides();
        }
      );

      // reset to select only 'all games' (formerly all leagues) when this received
      $scope.$on("favorites_reset_all_leagues", function() {
          $scope.selectAllLeagues(true);
      });

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/favoritesCarousel/favoritesCarouselController.js